module.exports = __webpack_public_path__ + "img/107.e0fb5659.jpg";